import React from 'react';
import { HeroBanner } from '../components/HeroBanner';
import { CTASection } from '../components/CTASection';
import { CheckCircle2 } from 'lucide-react';
export function AboutPage() {
  return <div className="flex flex-col w-full" data-id="element-116">
      <HeroBanner title="ABOUT US" subtitle="Orange County's trusted seamless rain gutter professionals since 2010." data-id="element-117" />

      <section className="py-20 px-4 bg-white" data-id="element-118">
        <div className="max-w-7xl mx-auto" data-id="element-119">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-120">
            <div data-id="element-121">
              <h2 className="text-3xl sm:text-4xl font-bold text-[#0c2340] mb-6" data-id="element-122">
                Committed to Protecting Your Home
              </h2>
              <div className="space-y-6 text-slate-600 text-lg" data-id="element-123">
                <p data-id="element-124">
                  At A-Flow Seamless Rain Gutters, we understand that your home
                  is your most valuable asset. Proper water management is
                  critical to protecting its foundation, siding, and landscaping
                  from costly water damage.
                </p>
                <p data-id="element-125">
                  As a locally owned and operated business in Orange County, we
                  take pride in delivering exceptional craftsmanship and
                  unparalleled customer service. We specialize in
                  custom-fabricated seamless aluminum and copper gutters that
                  not only function flawlessly but also enhance the
                  architectural beauty of your home.
                </p>
                <p data-id="element-126">
                  Our team of experienced installers treats every home as if it
                  were their own, ensuring precise measurements, secure
                  installations, and a clean workspace when the job is done.
                </p>
              </div>

              <div className="mt-10 space-y-4" data-id="element-127">
                {['Fully Licensed, Bonded, and Insured', 'Premium Materials (Aluminum & Copper)', 'Custom On-Site Fabrication', '100% Satisfaction Guarantee'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-128">
                    <CheckCircle2 className="w-6 h-6 text-[#b87333] shrink-0" data-id="element-129" />
                    <span className="font-medium text-slate-800" data-id="element-130">{item}</span>
                  </div>)}
              </div>
            </div>

            <div className="relative" data-id="element-131">
              <div className="aspect-square w-full rounded-2xl bg-slate-100 border border-slate-200 shadow-inner flex flex-col items-center justify-center p-12 text-center" data-id="element-132">
                <div className="w-24 h-24 bg-[#0c2340] rounded-full flex items-center justify-center mb-6" data-id="element-133">
                  <span className="text-3xl font-bold text-white" data-id="element-134">10+</span>
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-135">
                  Years of Excellence
                </h3>
                <p className="text-slate-500" data-id="element-136">
                  Serving Orange County and surrounding areas with top-tier
                  gutter solutions.
                </p>
              </div>
              <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-[#b87333]/10 rounded-full -z-10" data-id="element-137" />
              <div className="absolute -top-6 -right-6 w-32 h-32 bg-[#0c2340]/10 rounded-full -z-10" data-id="element-138" />
            </div>
          </div>
        </div>
      </section>

      <CTASection data-id="element-139" />
    </div>;
}